import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Grid, withStyles } from '@material-ui/core';
import moment from 'moment';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import * as Colors from '../../../../themes/summaryReportColor';

export const materialTheme = createMuiTheme({
  typography: {
    fontFamily: ['Kanit', 'sans-serif'].join(','),
    useNextVariants: true,
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#009D9A',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        backgroundColor: 'white',
        color: '#009D9A',
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: 7,
      },
      notchedOutline: {
        border: '1px solid #B8CFC3 !important',
        borderRadius: '2px',
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: '265px',
      },
    },
    MuiPickersDay: {
      isSelected: {
        backgroundColor: '#009D9A',
        opacity: '70%',
      },
      day: {
        fontSize: '0.85rem',
      },
    },
    MuiButton: {
      root: {
        color: '#009D9A !important',
      },
    },
    MuiTypography: {
      caption: {
        fontSize: '0.85rem',
      },
    },
  },
});

function CustomCalendar(props) {
  const disableDates = (date) => {
    const dateCurrent = moment(new Date(date)).format('YYYY-MM-DD');
    if (dateCurrent === props.today) {
      return false;
    }
    return !props.includeDates.includes(dateCurrent);
  };

  return (
    <div>
      <MuiThemeProvider theme={materialTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            id='datepicker'
            maxDate={new Date()}
            variant='outlined'
            className='datepicker'
            value={props.date || new Date()}
            onChange={(e) => props.onDateChange(e)}
            format='dd/MM/yyyy'
            InputProps={{ classes: { input: 'without-padding' } }}
            shouldDisableDate={disableDates}
            renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
              const _date = moment(new Date(day));
              const dateCurrent = moment(_date).format('YYYY-MM-DD');
              const isMotionTracker = isInCurrentMonth && props.dateMotionTracker.includes(dateCurrent);
              const isSOS = isInCurrentMonth && props.dateSOS.includes(dateCurrent);
              const isBeaconTag = isInCurrentMonth && props.dateBeaconTag.includes(dateCurrent);
              const isVitalSigns = isInCurrentMonth && props.dateVitalSigns.includes(dateCurrent);

              return (
                <div>
                  <Grid item>{dayComponent}</Grid>
                  <Grid item container direction='row' justify='center'>
                    {isMotionTracker && (
                      <FiberManualRecordIcon
                        style={{ color: Colors.COLOR_DEVICE_AIRNODE, fontSize: 10, marginTop: -2 }}
                      />
                    )}
                    {isSOS && (
                      <FiberManualRecordIcon
                        style={{ color: Colors.COLOR_DEVICE_EMERGENCY, fontSize: 10, marginTop: -2 }}
                      />
                    )}
                    {isBeaconTag && (
                      <FiberManualRecordIcon
                        style={{ color: Colors.COLOR_DEVICE_BEACON, fontSize: 10, marginTop: -2 }}
                      />
                    )}
                    {isVitalSigns && (
                      <FiberManualRecordIcon style={{ color: Colors.COLOR_VITALSIGN, fontSize: 10, marginTop: -2 }} />
                    )}
                  </Grid>
                </div>
              );
            }}
          />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </div>
  );
}

export default withStyles({ withTheme: true })(CustomCalendar);
